export const standardDimension = [
    {
        id: 0,
        beltWidth: 400,
        girderWidth: 720,
    },
    {
        id: 1,
        beltWidth: 450,
        girderWidth: 770,
    },
    {
        id: 2,
        beltWidth: 500,
        girderWidth: 820,
    },
    {
        id: 3,
        beltWidth: 600,
        girderWidth: 920,
    },
    {
        id: 4,
        beltWidth: 650,
        girderWidth: 1000,
    },
    {
        id: 5,
        beltWidth: 750,
        girderWidth: 1120,
    },
    {
        id: 6,
        beltWidth: 800,
        girderWidth: 1170,
    },
    {
        id: 7,
        beltWidth: 900,
        girderWidth: 1270,
    },
    {
        id: 8,
        beltWidth: 1000,
        girderWidth: 1370,
    },
    {
        id: 9,
        beltWidth: 1050,
        girderWidth: 1420,
    },
    {
        id: 10,
        beltWidth: 1200,
        girderWidth: 1270,
    },
    {
        id: 11,
        beltWidth: 1400,
        girderWidth: 1810,
    },
    {
        id: 12,
        beltWidth: 1600,
        girderWidth: 2010,
    },
    {
        id: 13,
        beltWidth: 1800,
        girderWidth: 2300,
    },
    {
        id: 14,
        beltWidth: 2000,
        girderWidth: 2500,
    },
    {
        id: 15,
        beltWidth: 2200,
        girderWidth: 2740,
    },
    {
        id: 16,
        beltWidth: 2400,
        girderWidth: 2950,
    },
    {
        id: 17,
        beltWidth: 2600,
        girderWidth: 3200,
    },
    {
        id: 18,
        beltWidth: 2800,
        girderWidth: 3450,
    },
    {
        id: 19,
        beltWidth: 3000,
        girderWidth: 3650,
    },
];
